import { createFileRoute } from '@tanstack/react-router';
import { Authn } from '@frontend/auth';
import { SsoTenantLogin } from '../../components';

export const Route = createFileRoute('/sso/')({
  component: SsoTenantWithoutRouteParam,
});

function SsoTenantWithoutRouteParam() {
  const auth: Authn = Route.useRouteContext({ select: (ctx) => ctx.auth });
  const navigate = Route.useNavigate();

  return <SsoTenantLogin<`/sso`> {...{ auth, navigate }} />;
}
